'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = makeI18n;

var _is = require('is');

var _is2 = _interopRequireDefault(_is);

var _jed = require('jed');

var _jed2 = _interopRequireDefault(_jed);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('./config');

var I18N = (function () {
    function I18N(activeLanguage, defaultLanguage, localeData) {
        _classCallCheck(this, I18N);

        if (process.env.NODE_ENV !== 'production') {
            if (!_is2['default'].object(localeData) || _Object$keys(localeData).length === 0) {
                (0, _config.getLogger)().error('No languages defined');
                localeData = {};
            }

            if (!defaultLanguage) {
                (0, _config.getLogger)().error('Default language not defined');
            }

            if (_is2['default'].undef(localeData[defaultLanguage])) {
                (0, _config.getLogger)().error('Default language not in available languages');
            }
        }

        this.localeData = localeData;
        this.requestLanguage = activeLanguage || defaultLanguage;

        this._activeLang = null;
        this.$t = null;

        // Set active language if specified
        if (activeLanguage) {
            this.setActiveLang(activeLanguage);
        }
    }

    _createClass(I18N, [{
        key: 'forceLanguage',
        value: function forceLanguage(activeLanguage) {
            this.requestLanguage = activeLanguage || activeLanguage;
            this.setActiveLang(this.requestLanguage);
        }
    }, {
        key: 'setActiveLang',
        value: function setActiveLang(theLanguage) {
            if (!_is2['default'].undef(this.localeData[theLanguage])) {
                if (this._activeLang !== theLanguage) {
                    if (!this.localeData[theLanguage]) {
                        (0, _config.getLogger)().warning('Missing locale_data for language ' + theLanguage);
                        return;
                    }

                    this._activeLang = theLanguage;
                    this.$t = new _jed2['default']({
                        domain: (0, _config.getConfig)('domain'),
                        locale_data: {
                            django: JSON.parse(this.localeData[theLanguage] || '{}')
                        }
                    });

                    if (theLanguage !== this.requestLanguage) {
                        (0, _config.onLanguageChange)(theLanguage);
                    }
                }
            }

            // Also fix moment locale
            _moment2['default'].locale(theLanguage === 'en-us' ? 'en-gb' : theLanguage);
        }
    }, {
        key: 'gettext',
        value: function gettext(key) {
            if (!this.$t) {
                return key;
            }

            return this.$t.gettext.apply(this.$t, [].slice.call(arguments));
        }
    }, {
        key: 'pgettext',
        value: function pgettext(context, key) {
            if (!this.$t) {
                return key;
            }

            return this.$t.pgettext.apply(this.$t, [].slice.call(arguments));
        }
    }, {
        key: 'ngettext',
        value: function ngettext(singularKey, pluralKey, value) {
            if (!this.$t) {
                return value === 0 || value === 1 ? singularKey : pluralKey;
            }

            return this.$t.ngettext.apply(this.$t, [].slice.call(arguments));
        }
    }, {
        key: 'npgettext',
        value: function npgettext(context, singularKey, pluralKey, value) {
            if (!this.$t) {
                return value === 0 || value === 1 ? singularKey : pluralKey;
            }

            return this.$t.npgettext.apply(this.$t, [].slice.call(arguments));
        }
    }, {
        key: 'sprintf',
        value: function sprintf(out) {
            if (!this.$t) {
                return out;
            }

            return this.$t.sprintf.apply(this.$t, [].slice.call(arguments));
        }
    }], [{
        key: 'initFromConfig',
        value: function initFromConfig() {
            return new I18N((0, _config.getConfig)('activeLanguage'), (0, _config.getConfig)('languageCode'), (0, _config.getConfig)('localeData'));
        }
    }]);

    return I18N;
})();

function makeI18n() {
    var i18n = I18N.initFromConfig();

    return {
        i18n: i18n,
        gettext: i18n.gettext.bind(i18n),
        pgettext: i18n.pgettext.bind(i18n),
        ngettext: i18n.ngettext.bind(i18n),
        npgettext: i18n.npgettext.bind(i18n),
        sprintf: i18n.sprintf.bind(i18n)
    };
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-i18n/dist/i18n.js
 ** module id = 1049
 ** module chunks = 1
 **/